import { gql } from 'graphql-request';
import { prismicGraphQLClient } from '../prismic-service';
import { FaqsQuery } from '../../../../graphql/generated';
import { filterUndefined } from '../../utils/fn';
import { Faqs, FaqsSchema, FaqsService } from './faqs-service';

const FAQS = gql`
  query faqs {
    allFaq_pages {
      edges {
        node {
          _meta {
            id
          }
          categories {
            faq_categories {
              ... on Faq_category {
                __typename
                _meta {
                  id
                }
                category
                faqs {
                  faq {
                    ... on Faq {
                      __typename
                      _meta {
                        id
                      }
                      title
                      answer
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export class PrismicFaqsService implements FaqsService {
  async loadFaqs(): Promise<Faqs> {
    const data: FaqsQuery = await prismicGraphQLClient.request(FAQS);

    const page = data.allFaq_pages.edges?.[0]?.node;

    if (!page) {
      return [];
    }

    const allFaqs = page.categories?.map((category) => {
      if (category.faq_categories?.__typename === 'Faq_category') {
        const questions = category.faq_categories?.faqs
          ?.map((faq) => {
            if (faq.faq?.__typename === 'Faq') {
              return {
                id: faq.faq?._meta?.id,
                title: faq.faq?.title,
                answer: faq.faq?.answer,
              };
            }
          })
          .filter(filterUndefined);

        return {
          id: category.faq_categories._meta?.id,
          title: category.faq_categories?.category,
          questions: questions ?? [],
        };
      }
    });

    return FaqsSchema.parse(allFaqs);
  }
}
